import Game01 from "./Game01";

export default {
  ...Game01,
};
